import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBExportProfile, DBExportProfileMapping, DBExportType } from '@/types/export';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  exportProfileId: number;
  data: {
    persist: boolean;
    name: string;
    export_type: DBExportType;
    field_mapping: DBExportProfileMapping[];
  };
};

type Response = DBExportProfile;

export const updateExportProfile = async (
  scope: RequestScope,
  { exportProfileId, data }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const response = await scopedApi(scope).put<EndpointResponse<Response>>(`/export_profile/${exportProfileId}`, data, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
